/** Функция для определения окончания и склонения слова, в зависимости от количества
 * @param count количество элементов
 * @param declensionForms список склонений существительного
 *
 * Пример: getPluralEnding(4, ["сотрудник", "сотрудника", "сотрудников"]) -> "сотрудника"
 */
export const getPluralEnding = (count: number, declensionForms: string[]) => {
  const remainderDivisionByHundred = Math.abs(count) % 100;
  const remainderDivisionByTen = remainderDivisionByHundred % 10;

  if (remainderDivisionByHundred > 10 && remainderDivisionByHundred < 20) {
    return declensionForms[2];
  }

  if (remainderDivisionByTen > 1 && remainderDivisionByTen < 5) {
    return declensionForms[1];
  }

  if (remainderDivisionByTen === 1) {
    return declensionForms[0];
  }

  return declensionForms[2];
};
